<template>
  <div class="standard-feature-page">
    <div class="standard-feature-layout">
      <div class="standard-side-panel">
        <!-- 1. 动态标题基础配置 -->
        <div class="panel-card tech-card">
          <div class="card-header">
            <div class="icon-wrapper">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <path d="M4 7V4h16v3"/><path d="M9 20h6"/><path d="M12 4v16"/>
              </svg>
            </div>
            <span>AI动态标题设置</span>
            <label class="header-toggle" style="margin-left: auto;">
              <input type="checkbox" v-model="config.enabled" />
              <span class="toggle-track"></span>
            </label>
          </div>
          <div class="card-body">
            <div class="config-list" :class="{ disabled: !config.enabled }">
              <!-- 标题组选择与频率合并一行 -->
              <div class="config-row-compact">
                <div class="config-item flex-1">
                  <label>标题组</label>
                  <select v-model="config.currentGroupId" class="cyber-select-mini" @change="onGroupChange">
                    <option v-for="group in titleGroups" :key="group.id" :value="group.id">{{ group.name }}</option>
                  </select>
                </div>
                <div class="config-item flex-2">
                  <div class="label-row">
                    <label>频率 (秒)</label>
                    <span class="value-tag">{{ config.intervalMin }}-{{ config.intervalMax }}s</span>
                  </div>
                  <div class="input-with-unit">
                    <input type="number" v-model.number="config.intervalMin" class="cyber-input-mini no-arrows" min="1" max="600" />
                    <span class="unit">-</span>
                    <input type="number" v-model.number="config.intervalMax" class="cyber-input-mini no-arrows" min="1" max="600" />
                    <label class="auto-switch-mini" title="开启后自动切换标题组">
                      <input type="checkbox" v-model="config.autoGroupSwitch" />
                      <span class="auto-switch-track"></span>
                    </label>
                  </div>
                </div>
              </div>

              <!-- 第一段内容分组 -->
              <div class="config-group-section" >
                <div class="section-divider">
                  <div class="divider-dot"></div>
                  <span class="divider-text">第一段内容</span>
                  <div class="divider-line"></div>
                </div>

                <div class="style-field" style="margin-top: 12px; align-items: stretch; padding: 0;">
                  <div class="input-wrapper-styled-large">
                    <input type="text" v-model="config.firstTitleText" class="cyber-input-large-styled" placeholder="在此输入第一段标题内容..." />
                  </div>
                </div>

                <div class="config-item" style="margin-top: 10px;">
                  <div class="style-grid-quad">
                    <div class="style-field">
                      <label>背景</label>
                      <div class="color-picker-wrap-compact">
                        <input type="color" v-model="config.firstTitleBg" />
                      </div>
                    </div>
                    <div class="style-field">
                      <label>文字</label>
                      <input type="color" v-model="config.firstTitleColor" class="full-color-mini" />
                    </div>
                    <div class="style-field">
                      <label>阴影</label>
                      <input type="color" v-model="config.firstTitleShadow" class="full-color-mini" />
                    </div>
                    <div class="style-field">
                      <label>字号</label>
                      <div class="input-with-unit-compact">
                        <input type="number" v-model.number="config.firstTitleSize" class="cyber-input-mini-compact" min="10" max="32" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- 第二段内容分组 -->
              <div class="config-group-section" style="margin-top: 16px;">
                <div class="section-divider">
                  <div class="divider-dot" style="background: #ffeb3b; box-shadow: 0 0 8px #ffeb3b;"></div>
                  <span class="divider-text" style="color: #ffeb3b;">第二段内容</span>
                  <div class="divider-line" style="background: linear-gradient(90deg, rgba(255, 235, 59, 0.2), transparent);"></div>
                </div>

                <div class="style-field" style="margin-top: 12px; align-items: stretch; padding: 0;">
                  <div class="input-wrapper-styled-large" style="border-color: rgba(255, 235, 59, 0.2);">
                    <input type="text" v-model="config.secondTitleText" class="cyber-input-large-styled" placeholder="在此输入第二段标题内容..." />
                  </div>
                </div>

                <div class="config-item" style="margin-top: 10px;">
                  <div class="style-grid-quad">
                    <div class="style-field">
                      <label>背景</label>
                      <div class="color-picker-wrap-compact">
                        <input type="color" v-model="config.secondTitleBg" />
                      </div>
                    </div>
                    <div class="style-field">
                      <label>文字</label>
                      <input type="color" v-model="config.secondTitleColor" class="full-color-mini" />
                    </div>
                    <div class="style-field">
                      <label>阴影</label>
                      <input type="color" v-model="config.secondTitleShadow" class="full-color-mini" />
                    </div>
                    <div class="style-field">
                      <label>字号</label>
                      <div class="input-with-unit-compact">
                        <input type="number" v-model.number="config.secondTitleSize" class="cyber-input-mini-compact" min="10" max="32" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- 第三段内容分组 -->
              <div class="config-group-section" style="margin-top: 16px;">
                <div class="section-divider">
                  <div class="divider-dot" style="background: #9c27b0; box-shadow: 0 0 8px #9c27b0;"></div>
                  <span class="divider-text" style="color: #9c27b0;">第三段内容</span>
                  <div class="divider-line" style="background: linear-gradient(90deg, rgba(156, 39, 176, 0.2), transparent);"></div>
                </div>

                <div class="style-field" style="margin-top: 12px; align-items: stretch; padding: 0;">
                  <div class="input-wrapper-styled-large" style="border-color: rgba(156, 39, 176, 0.2);">
                    <input type="text" v-model="config.thirdTitleText" class="cyber-input-large-styled" placeholder="在此输入第三段标题内容..." />
                  </div>
                </div>

                <div class="config-item" style="margin-top: 10px;">
                  <div class="style-grid-quad">
                    <div class="style-field">
                      <label>背景</label>
                      <div class="color-picker-wrap-compact">
                        <input type="color" v-model="config.thirdTitleBg" />
                      </div>
                    </div>
                    <div class="style-field">
                      <label>文字</label>
                      <input type="color" v-model="config.thirdTitleColor" class="full-color-mini" />
                    </div>
                    <div class="style-field">
                      <label>阴影</label>
                      <input type="color" v-model="config.thirdTitleShadow" class="full-color-mini" />
                    </div>
                    <div class="style-field">
                      <label>字号</label>
                      <div class="input-with-unit-compact">
                        <input type="number" v-model.number="config.thirdTitleSize" class="cyber-input-mini-compact" min="10" max="32" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>

      <div class="standard-center-preview">
        <div class="standard-phone-frame">
          <div class="standard-phone-screen" >
            <!-- 实时推流预览层 (当驱动开启时显示) -->

            <canvas
                ref="videoCanvas"
                class="video-element"

                :style="{
                        position: 'absolute',
                        width: '100%',
                        height: '100%',
                        opacity: 1,
                        pointerEvents: 'auto',
                        zIndex: 1
                      }"
            ></canvas>


            <!-- 直播间 UI 遮罩 + 动态标题层 -->
            <div class="live-ui-overlay">
              <div class="live-header">
                <div class="user-info-capsule">
                  <div class="avatar"><img src="https://api.dicebear.com/7.x/avataaars/svg?seed=Douyin" alt="avatar"></div>
                  <div class="meta">
                    <div class="name">MULTIFACED</div>
                    <div class="stats">12.8w 点赞</div>
                  </div>
                  <div class="follow">+ 关注</div>
                </div>
                <div class="viewer-tag">
                  <span class="val">3821</span>
                  <span class="lab">人</span>
                </div>
              </div>


            </div>

            <!-- 独立拖拽标题预览 -->
            <div class="draggable-title-container">
              <!-- 第一段 -->
              <div v-if="config.enabled && config.firstTitleText && config.firstTitleText.trim()" class="draggable-title-item"
                   :style="getTitleStyle(config.title1Pos, firstTitleStyle)"
                   :class="{ dragging: draggingItem === 'title1Pos' }"
                   @mousedown="onDragStart($event, 'title1Pos')">
                {{ config.firstTitleText }}
              </div>

              <!-- 第二段 -->
              <div v-if="config.enabled && config.secondTitleText && config.secondTitleText.trim()" class="draggable-title-item"
                   :style="getTitleStyle(config.title2Pos, secondTitleStyle)"
                   :class="{ dragging: draggingItem === 'title2Pos' }"
                   @mousedown="onDragStart($event, 'title2Pos')">
                {{ config.secondTitleText }}
              </div>

              <!-- 第三段 -->
              <div v-if="config.enabled && config.thirdTitleText && config.thirdTitleText.trim()" class="draggable-title-item"
                   :style="getTitleStyle(config.title3Pos, thirdTitleStyle)"
                   :class="{ dragging: draggingItem === 'title3Pos' }"
                   @mousedown="onDragStart($event, 'title3Pos')">
                {{ config.thirdTitleText }}
              </div>

              <!-- 装饰图片 -->
              <template>
                <div v-for="dec in config.decorations"
                     :key="dec.id"
                     class="draggable-dec-item"
                     :style="getDecStyle(dec)"
                     :class="{ dragging: draggingDecId === dec.id, 'is-arrow': dec.isArrow }"
                     @mousedown="onDecDragStart($event, dec.id)"
                     @wheel.prevent="onDecWheel($event, dec)">
                  <img :src="(dec.url.startsWith('E:') || dec.url.startsWith('D:')) ? 'http://localhost:3000/proxy_image?path=' + dec.url : dec.url" />
                  <button class="dec-remove-btn" @mousedown.stop="removeDecoration(dec.id)">×</button>

                  <!-- 仅箭头显示旋转手柄 -->
                  <div v-if="dec.isArrow"
                       class="dec-rotate-handle"
                       @mousedown.stop="onRotateStart($event, dec)">
                    <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3">
                      <path d="M23 4v6h-6M1 20v-6h6M3.51 9a9 9 0 0 1 14.85-3.36L23 10M1 14l4.64 4.36A9 9 0 0 0 20.49 15"/>
                    </svg>
                  </div>
                </div>
              </template>
            </div>
          </div>


        </div>
      </div>

      <div class="standard-side-panel" style="gap: 12px;">
        <!-- 2. 图片装饰库 -->
        <div class="panel-card tech-card" style="margin-bottom: 0px;">
          <div class="card-header">
            <div class="icon-wrapper" style="background: rgba(76, 175, 80, 0.12); color: #4caf50;">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <rect x="3" y="3" width="18" height="18" rx="2" ry="2"/><circle cx="8.5" cy="8.5" r="1.5"/><polyline points="21 15 16 10 5 21"/>
              </svg>
            </div>
            <span>图片装饰库</span>
            <div style="margin-left: auto;">
              <button class="refresh-btn-mini" @click="loadFixedDecorations">刷新</button>
            </div>
          </div>
          <div class="card-body" style="min-height: auto; padding-top: 10px; padding-bottom: 15px;">
            <!-- 统一素材管理区 (无额外表头，直接显示网格) -->
            <div class="unified-assets-scroll-box">
              <div class="unified-assets-grid">
                <!-- 1. 目录素材 -->
                <div v-for="(url, idx) in fixedDecorations"
                     :key="'fixed-'+idx"
                     class="asset-item-box"
                     @click="addDecorationToStage(url, false)"
                     :title="url ? url.split(/[/\\]/).pop() : ''">
                  <div class="asset-img-wrap">
                    <img v-if="url" :src="url" />
                  </div>
                  <span class="asset-badge">库</span>
                </div>

                <!-- 2. 上传素材 -->
                <div v-for="dec in uploadedDecorations"
                     :key="dec.id"
                     class="asset-item-box uploaded"
                     @click="addDecorationToStage(dec.url, false)">
                  <div class="asset-img-wrap">
                    <img :src="dec.url" />
                  </div>
                  <span class="asset-badge up">新</span>
                  <button class="asset-del-btn" @click.stop="uploadedDecorations = uploadedDecorations.filter(d => d.id !== dec.id)">×</button>
                </div>

                <!-- 3. 上传按钮占位 -->
                <label class="asset-item-box upload-trigger" title="点击上传本地图片">
                  <input type="file" hidden accept="image/*" multiple @change="handleDecorationUpload" />
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><path d="M12 5v14M5 12h14"/></svg>
                </label>
              </div>
            </div>
          </div>
        </div>

        <!-- 3. 箭头素材库 (独立面板) -->
        <div class="panel-card tech-card">
          <div class="card-header">
            <div class="icon-wrapper" style="background: rgba(255, 235, 59, 0.12); color: #ffeb3b;">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <line x1="7" y1="17" x2="17" y2="7"/><polyline points="7 7 17 7 17 17"/>
              </svg>
            </div>
            <span>箭头素材库</span>
            <div style="margin-left: auto;">
              <button class="refresh-btn-mini" @click="loadFixedDecorations">刷新</button>
            </div>
          </div>
          <div class="card-body" style="min-height: auto; padding-top: 10px; padding-bottom: 15px;">
            <div class="unified-assets-scroll-box">
              <div class="unified-assets-grid">
                <!-- 1. 目录素材 -->
                <div v-for="(url, idx) in arrowDecorations"
                     :key="'arrow-'+idx"
                     class="asset-item-box"
                     @click="addDecorationToStage(url, true)"
                     style="border-color: rgba(255, 235, 59, 0.15);"
                     :title="url ? url.split(/[/\\]/).pop() : ''">
                  <div class="asset-img-wrap">
                    <img v-if="url" :src="url" />
                  </div>
                  <span class="asset-badge" style="background: #ffeb3b; color: #000;">箭头</span>
                </div>

                <!-- 2. 上传素材 -->
                <div v-for="dec in uploadedArrows"
                     :key="dec.id"
                     class="asset-item-box uploaded"
                     @click="addDecorationToStage(dec.url, true)"
                     style="border-color: rgba(255, 235, 59, 0.3);">
                  <div class="asset-img-wrap">
                    <img :src="dec.url" />
                  </div>
                  <span class="asset-badge up" style="background: #ffeb3b; color: #000;">新</span>
                  <button class="asset-del-btn" @click.stop="uploadedArrows = uploadedArrows.filter(d => d.id !== dec.id)">×</button>
                </div>

                <!-- 3. 上传按钮占位 -->
                <label class="asset-item-box upload-trigger" title="点击上传本地箭头图片" style="border-color: rgba(255, 235, 59, 0.2);">
                  <input type="file" hidden accept="image/*" multiple @change="handleArrowUpload" />
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" style="color: #ffeb3b;"><path d="M12 5v14M5 12h14"/></svg>
                </label>

                <div v-if="arrowDecorations.length === 0 && uploadedArrows.length === 0" class="empty-static-tip" style="grid-column: span 4; text-align: center; padding: 20px; color: #666;">
                  <small>D:\去重1\arrow 路径下无图片</small>
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DynamicTitle',
  inject: ['syncCanvasToTarget', 'globalCanvasState'],
  data() {
    return {
      // --- 1. 核心配置状态 ---
      titleGroups: [
        {
          id: 1,
          name: '标题组 A',
          titles: [
            '爆款女装，限时 3 折起！速抢！',
            '【直播限定】新人立减 50 元，点击进入',
            '老板疯了！全场买一送一，仅限 1 小时'
          ]
        },
        {
          id: 2,
          name: '标题组 B',
          titles: [
            '气质女神范，今天穿什么？',
            '新品首发 | 只有在这里才能买到的独家款',
            '评论区回复“666”抽送精美礼品'
          ]
        },
        {
          id: 3,
          name: '标题组 C',
          titles: [
            '居家好物，提升幸福感的小物件',
            '千万博主推荐！年度最好用的单品合集',
            '最后 10 分钟！卖完即止，永不补货'
          ]
        }
      ],
      config: {
        enabled: false,
        currentGroupId: 1,
        intervalMin: 5,
        intervalMax: 15,
        autoGroupSwitch: false,
        decorationsEnabled: true,
        selectedDecPath: '',
        firstTitleText: '爆款女装，限时 3 折起！速抢！',
        firstTitleBg: '#ff0000',
        firstTitleBgOpacity: 80,
        firstTitleColor: '#ffffff',
        firstTitleShadow: '#000000',
        firstTitleSize: 14,
        firstTitleLetterSpacing: 1,
        secondTitleText: '限时秒杀，仅此一天！速抢！',
        secondTitleBg: '#00d4ff',
        secondTitleBgOpacity: 80,
        secondTitleColor: '#ffffff',
        secondTitleShadow: '#000000',
        secondTitleSize: 13,
        secondTitleLetterSpacing: 0.5,
        thirdTitleText: '官方正品保障，假一赔十',
        thirdTitleBg: '#9c27b0',
        thirdTitleBgOpacity: 80,
        thirdTitleColor: '#ffffff',
        thirdTitleShadow: '#000000',
        thirdTitleSize: 12,
        thirdTitleLetterSpacing: 0,
        title1Pos: { x: 20, y: 60 },
        title2Pos: { x: 20, y: 100 },
        title3Pos: { x: 20, y: 135 },
        decorations: []
      },

      // --- 装饰图片管理 ---
      fixedDecorations: [],
      arrowDecorations: [],
      uploadedDecorations: [],
      uploadedArrows: [],

      // --- 预览状态 ---
      previewScale: 1,
      previewOffsetX: 0,
      previewOffsetY: 0,
      resizeTimer: null,
      
      // --- 拖拽状态 ---
      draggingItem: null,
      dragOffset: { x: 0, y: 0 },
      draggingDecId: null,

      // --- 倒计时和标题状态 ---
      newTitle: '',
      currentTitleIndex: 0,
      countdown: 10,

      // --- 2. 播放器与 UI 状态 ---
      isPlaying: false,
      currentTime: 0,
      duration: 0,
      volume: 1,
      isPageActive: true,
      isInitialSync: false,
      isMuted: true,
      lastDeactivatedTime: 0,
      lastDeactivatedProgress: 0,

      // --- 定时器 ---
      timer: null,
      playbackWatchdog: null,
      
      // Canvas 同步相关
      canvasSyncTimer: null,

      // --- watch 取消函数 ---
      unwatchVolume: null,
      unwatchVideoUrl: null,
      unwatchConfig: null,
      unwatchGroupConfig: null
    }
  },
  computed: {
    firstTitleStyle() {
      const r = parseInt(this.config.firstTitleBg.slice(1, 3), 16)
      const g = parseInt(this.config.firstTitleBg.slice(3, 5), 16)
      const b = parseInt(this.config.firstTitleBg.slice(5, 7), 16)
      const a = this.config.firstTitleBgOpacity / 100

      return {
        backgroundColor: `rgba(${r}, ${g}, ${b}, ${a})`,
        color: this.config.firstTitleColor,
        textShadow: `0 ${2 * this.previewScale}px ${4 * this.previewScale}px ${this.config.firstTitleShadow}`,
        fontSize: `${this.config.firstTitleSize * this.previewScale}px`,
        padding: `${6 * this.previewScale}px ${12 * this.previewScale}px`,
        borderRadius: `${4 * this.previewScale}px`,
        marginBottom: `${6 * this.previewScale}px`,
        display: 'inline-block',
        fontWeight: 'bold',
        backdropFilter: 'blur(4px)',
        border: `${1 * this.previewScale}px solid rgba(255,255,255,0.1)`,
        letterSpacing: `${this.config.firstTitleLetterSpacing * this.previewScale}px`
      }
    },
    secondTitleStyle() {
      const r = parseInt(this.config.secondTitleBg.slice(1, 3), 16)
      const g = parseInt(this.config.secondTitleBg.slice(3, 5), 16)
      const b = parseInt(this.config.secondTitleBg.slice(5, 7), 16)
      const a = this.config.secondTitleBgOpacity / 100

      return {
        backgroundColor: `rgba(${r}, ${g}, ${b}, ${a})`,
        color: this.config.secondTitleColor,
        textShadow: `0 ${2 * this.previewScale}px ${4 * this.previewScale}px ${this.config.secondTitleShadow}`,
        fontSize: `${this.config.secondTitleSize * this.previewScale}px`,
        padding: `${5 * this.previewScale}px ${10 * this.previewScale}px`,
        borderRadius: `${4 * this.previewScale}px`,
        marginBottom: `${6 * this.previewScale}px`,
        display: 'inline-block',
        fontWeight: '600',
        backdropFilter: 'blur(4px)',
        border: `${1 * this.previewScale}px solid rgba(255,255,255,0.1)`,
        letterSpacing: `${this.config.secondTitleLetterSpacing * this.previewScale}px`
      }
    },
    thirdTitleStyle() {
      const r = parseInt(this.config.thirdTitleBg.slice(1, 3), 16)
      const g = parseInt(this.config.thirdTitleBg.slice(3, 5), 16)
      const b = parseInt(this.config.thirdTitleBg.slice(5, 7), 16)
      const a = this.config.thirdTitleBgOpacity / 100

      return {
        backgroundColor: `rgba(${r}, ${g}, ${b}, ${a})`,
        color: this.config.thirdTitleColor,
        textShadow: `0 ${2 * this.previewScale}px ${4 * this.previewScale}px ${this.config.thirdTitleShadow}`,
        fontSize: `${this.config.thirdTitleSize * this.previewScale}px`,
        padding: `${5 * this.previewScale}px ${10 * this.previewScale}px`,
        borderRadius: `${4 * this.previewScale}px`,
        marginBottom: `${8 * this.previewScale}px`,
        display: 'inline-block',
        fontWeight: '500',
        backdropFilter: 'blur(4px)',
        border: `${1 * this.previewScale}px solid rgba(255,255,255,0.1)`,
        letterSpacing: `${this.config.thirdTitleLetterSpacing * this.previewScale}px`
      }
    },
    currentGroup() {
      return this.titleGroups.find(g => g.id === this.config.currentGroupId) || this.titleGroups[0]
    },
    currentTitle() {
      if (!this.currentGroup.titles.length) return '暂无标题'
      return this.currentGroup.titles[this.currentTitleIndex]
    },
    formatCountdown() {
      const m = Math.floor(this.countdown / 60)
      const s = this.countdown % 60
      return `${m.toString().padStart(2, '0')}:${s.toString().padStart(2, '0')}`
    },
    isVirtualCameraLive() {
      return this.$store.state.isVirtualCameraLive
    },
    videoUrl() {
      if (this.isVirtualCameraLive) return null
      const url = this.$store.state.currentMedia?.url
      return (url && typeof url === 'string' && url.trim() !== '') ? url : null
    },
    progressPercent() {
      if (!this.duration) return 0
      return (this.currentTime / this.duration) * 100
    },
    videoPlayerRef() {
      return this.$refs.videoPlayerRef
    }
  },
  methods: {
    // 启动 canvas 同步
    startCanvasSync() {
      if (this.syncCanvasFrameId) {
        cancelAnimationFrame(this.syncCanvasFrameId)
      }
      const sync = () => {
        const videoCanvas = this.$refs.videoCanvas
        if (videoCanvas) {
          this.syncCanvasToTarget(videoCanvas)
        }
        this.syncCanvasFrameId = requestAnimationFrame(sync)
      }
      sync()
    },

    // 停止 canvas 同步
    stopCanvasSync() {
      if (this.canvasSyncTimer) {
        clearInterval(this.canvasSyncTimer)
        this.canvasSyncTimer = null
      }
    },

    // --- 装饰图片管理方法 ---
    async loadFixedDecorations() {
      try {
        // 直接从 public 目录读取 follow 目录的图片
        const followImages = []
        for (let i = 1; i <= 10; i++) {

          followImages.push(require("@/access/follow/"+i+".png"))
        }
        this.fixedDecorations = followImages

        // 直接从 public 目录读取 arrow 目录的图片
        const arrowImages = []
        for (let i = 1; i <= 10; i++) {
          arrowImages.push(require("@/access/arrow/"+i+".png"))
        }
        this.arrowDecorations = arrowImages
      } catch (err) {
        console.error('加载装饰素材失败:', err)
      }
    },
    handleDecorationUpload(e) {
      const files = e.target.files
      if (!files) return

      for (let i = 0; i < files.length; i++) {
        const reader = new FileReader()
        reader.onload = (event) => {
          this.uploadedDecorations.push({
            id: 'up-' + Date.now() + '-' + i,
            url: event.target.result
          })
        }
        reader.readAsDataURL(files[i])
      }
    },
    handleArrowUpload(e) {
      const files = e.target.files
      if (!files) return

      for (let i = 0; i < files.length; i++) {
        const reader = new FileReader()
        reader.onload = (event) => {
          this.uploadedArrows.push({
            id: 'up-arrow-' + Date.now() + '-' + i,
            url: event.target.result
          })
        }
        reader.readAsDataURL(files[i])
      }
    },
    addDecorationToStage(url, isArrow = false) {
      this.config.decorations.push({
        id: 'dec-' + Date.now(),
        url: url,
        x: 50,
        y: 200,
        width: 100,
        height: 100,
        isArrow: isArrow,
        rotation: 0
      })
    },
    onDecWheel(e, dec) {
      const scaleSpeed = 0.1
      const delta = e.deltaY > 0 ? -1 : 1
      const scale = 1 + delta * scaleSpeed

      const minSize = 20
      const maxSize = 500

      const newWidth = Math.max(minSize, Math.min(maxSize, dec.width * scale))
      const newHeight = Math.max(minSize, Math.min(maxSize, dec.height * scale))

      dec.width = newWidth
      dec.height = newHeight
    },
    removeDecoration(id) {
      const idx = this.config.decorations.findIndex(d => d.id === id)
      if (idx > -1) this.config.decorations.splice(idx, 1)
    },
    addTitle() {
      if (this.newTitle.trim()) {
        this.currentGroup.titles.push(this.newTitle.trim())
        this.newTitle = ''
      }
    },
    
    // --- 倒计时和标题切换 ---
    startTimer() {
      if (this.timer) clearInterval(this.timer)

      const min = Math.min(this.config.intervalMin, this.config.intervalMax)
      const max = Math.max(this.config.intervalMin, this.config.intervalMax)
      this.countdown = Math.floor(Math.random() * (max - min + 1)) + min

      this.timer = setInterval(() => {
        if (this.config.enabled && this.countdown > 0) {
          this.countdown--
          if (this.countdown === 0) {
            if (this.config.autoGroupSwitch) {
              const nextGroupId = (this.config.currentGroupId % this.titleGroups.length) + 1
              this.config.currentGroupId = nextGroupId
            } else if (this.currentGroup.titles.length > 0) {
              this.currentTitleIndex = (this.currentTitleIndex + 1) % this.currentGroup.titles.length
            }

            const nextMin = Math.min(this.config.intervalMin, this.config.intervalMax)
            const nextMax = Math.max(this.config.intervalMin, this.config.intervalMax)
            this.countdown = Math.floor(Math.random() * (nextMax - nextMin + 1)) + nextMin
          } else if (!this.config.autoGroupSwitch && this.currentGroup.titles.length === 0) {
            this.countdown = 10
          }
        }
      }, 1000)
    },
    
    // --- 拖拽逻辑 ---
    onDragStart(e, itemKey) {
      e.preventDefault()
      const el = e.currentTarget
      this.draggingItem = itemKey
      this.draggingDecId = null

      const container = document.querySelector('.standard-phone-screen')
      if (!container) return
      const containerRect = container.getBoundingClientRect()
      
      // 计算容器的缩放比例（因为标准尺寸是360x640）
      const scale = containerRect.width / 360
      
      const rect = el.getBoundingClientRect()
      this.dragOffset.x = (e.clientX - rect.left) / scale
      this.dragOffset.y = (e.clientY - rect.top) / scale

      // 先测量一下标准尺寸下的元素大小
      const standardWidth = el.offsetWidth / scale
      const standardHeight = el.offsetHeight / scale
      
      const maxX = 360 - standardWidth
      const maxY = 640 - standardHeight

      const onMouseMove = (moveEvent) => {
        if (!this.draggingItem) return

        let newX = (moveEvent.clientX - containerRect.left) / scale - this.dragOffset.x
        let newY = (moveEvent.clientY - containerRect.top) / scale - this.dragOffset.y

        const pos = this.config[itemKey]
        if (pos) {
          pos.x = Math.max(0, Math.min(newX, maxX))
          pos.y = Math.max(0, Math.min(newY, maxY))
        }
      }

      const onMouseUp = () => {
        this.draggingItem = null
        this.draggingDecId = null
        document.removeEventListener('mousemove', onMouseMove)
        document.removeEventListener('mouseup', onMouseUp)
      }

      document.addEventListener('mousemove', onMouseMove)
      document.addEventListener('mouseup', onMouseUp)
    },
    onDecDragStart(e, id) {
      e.preventDefault()
      const el = e.currentTarget
      this.draggingDecId = id
      this.draggingItem = null

      const container = document.querySelector('.standard-phone-screen')
      if (!container) return
      const containerRect = container.getBoundingClientRect()

      const scale = containerRect.width / 360

      const rect = el.getBoundingClientRect()
      this.dragOffset.x = (e.clientX - rect.left) / scale
      this.dragOffset.y = (e.clientY - rect.top) / scale

      const standardWidth = el.offsetWidth / scale
      const standardHeight = el.offsetHeight / scale
      const maxX = 360 - standardWidth
      const maxY = 640 - standardHeight

      const onMouseMove = (moveEvent) => {
        const dec = this.config.decorations.find(d => d.id === id)

        if (dec) {
          let newX = (moveEvent.clientX - containerRect.left) / scale - this.dragOffset.x
          let newY = (moveEvent.clientY - containerRect.top) / scale - this.dragOffset.y
          dec.x = Math.max(0, Math.min(newX, maxX))
          dec.y = Math.max(0, Math.min(newY, maxY))
        }
      }

      const onMouseUp = () => {
        this.draggingDecId = null
        document.removeEventListener('mousemove', onMouseMove)
        document.removeEventListener('mouseup', onMouseUp)
      }
      document.addEventListener('mousemove', onMouseMove)
      document.addEventListener('mouseup', onMouseUp)
    },
    onRotateStart(e, dec) {
      e.preventDefault()
      const rect = e.currentTarget.parentElement.getBoundingClientRect()
      if (!rect) return

      const centerX = rect.left + rect.width / 2
      const centerY = rect.top + rect.height / 2

      const startAngle = Math.atan2(e.clientY - centerY, e.clientX - centerX) * 180 / Math.PI
      const initialRotation = dec.rotation || 0

      const onMouseMove = (moveEvent) => {
        const currentAngle = Math.atan2(moveEvent.clientY - centerY, moveEvent.clientX - centerX) * 180 / Math.PI
        const diff = currentAngle - startAngle
        dec.rotation = initialRotation + diff
      }

      const onMouseUp = () => {
        document.removeEventListener('mousemove', onMouseMove)
        document.removeEventListener('mouseup', onMouseUp)
      }

      document.addEventListener('mousemove', onMouseMove)
      document.addEventListener('mouseup', onMouseUp)
    },
    // 标题组切换时更新三段标题内容
    onGroupChange() {
      const selectedGroup = this.titleGroups.find(g => g.id === this.config.currentGroupId)
      if (selectedGroup && selectedGroup.titles) {
        // 更新第一段标题
        if (selectedGroup.titles[0]) {
          this.config.firstTitleText = selectedGroup.titles[0]
        }
        // 更新第二段标题
        if (selectedGroup.titles[1]) {
          this.config.secondTitleText = selectedGroup.titles[1]
        }
        // 更新第三段标题
        if (selectedGroup.titles[2]) {
          this.config.thirdTitleText = selectedGroup.titles[2]
        }
      }
    },
    getDecStyle(dec) {
      return {
        left: (dec.x * this.previewScale) + 'px',
        top: (dec.y * this.previewScale) + 'px',
        width: (dec.width * this.previewScale) + 'px',
        height: (dec.height * this.previewScale) + 'px',
        transform: 'rotate(' + (dec.rotation || 0) + 'deg)'
      }
    },
    getTitleStyle(pos, extraStyle) {
      return {
        left: (pos.x * this.previewScale) + 'px',
        top: (pos.y * this.previewScale) + 'px',
        ...extraStyle
      }
    },
    
    // --- 播放器方法 ---
    formatTime(seconds) {
      const mins = Math.floor(seconds / 60)
      const secs = Math.floor(seconds % 60)
      return `${mins}:${secs.toString().padStart(2, '0')}`
    },
    syncToStore() {
      if (!this.isPageActive || this.isInitialSync) return
      this.$store.commit('UPDATE_MEDIA_STATE', {
        currentTime: this.currentTime,
        isPlaying: this.isPlaying,
        duration: this.duration,
        url: this.videoUrl
      })
    },
    startPlaybackWatchdog() {
      if (this.playbackWatchdog) clearInterval(this.playbackWatchdog)
      this.playbackWatchdog = setInterval(() => {
        if (this.isPageActive && this.$store.state.currentMedia?.isPlaying && this.videoPlayerRef) {
          if (this.videoPlayerRef.paused && this.videoPlayerRef.readyState >= 2) {
            console.log('[DynamicTitle] Watchdog 发现播放异常停止，正在尝试恢复...')
            this.videoPlayerRef.play().catch(() => {})
          }
        }
      }, 2000)
    },
    stopPlaybackWatchdog() {
      if (this.playbackWatchdog) clearInterval(this.playbackWatchdog)
    },
    async performSync() {
      if (!this.videoPlayerRef || !this.isPageActive) return
      const currentMedia = this.$store.state.currentMedia
      if (!currentMedia) return

      try {
        let targetTime = currentMedia.currentTime || 0
        if (this.isVirtualCameraLive && currentMedia.isPlaying && this.lastDeactivatedTime > 0) {
          const elapsed = (Date.now() - this.lastDeactivatedTime) / 1000
          const speed = this.$store.state.audioParams?.speed || 1.0
          const compensation = elapsed * speed
          targetTime += compensation
          console.log(`[DynamicTitle] 离线补偿：离开 ${elapsed.toFixed(2)}s，补偿进度 ${compensation.toFixed(2)}s`)
        }

        if (Math.abs(this.videoPlayerRef.currentTime - targetTime) > 0.5) {
          this.videoPlayerRef.currentTime = targetTime
        }

        if (currentMedia.isPlaying) {
          this.isMuted = true
          await this.videoPlayerRef.play().catch(() => {
            console.warn('[DynamicTitle] 自动播放受阻')
          })

          this.startPlaybackWatchdog()

          const audioDelay = this.isVirtualCameraLive ? 450 : 0
          setTimeout(async () => {
            if (this.videoPlayerRef && this.isPageActive && this.$store.state.currentMedia?.isPlaying) {
              this.isMuted = false
              this.isPlaying = true
              const latestTime = this.$store.state.currentMedia?.currentTime || 0
              if (Math.abs(this.videoPlayerRef.currentTime - latestTime) > 0.5) {
                this.videoPlayerRef.currentTime = latestTime
              }
            }
          }, audioDelay)
        } else {
          this.videoPlayerRef.pause()
          this.isPlaying = false
        }
      } catch (e) {
        console.error('[DynamicTitle] 同步流程异常:', e)
      } finally {
        setTimeout(() => { this.isInitialSync = false }, 500)
      }
    },
    async togglePlayback() {
      if (!this.videoPlayerRef) return

      const wasPlaying = this.isPlaying
      this.isPlaying = !wasPlaying

      if (wasPlaying) {
        this.videoPlayerRef.pause()
      } else {
        const audioDelay = this.isVirtualCameraLive ? 450 : 0
        setTimeout(() => {
          if (this.isPlaying && this.videoPlayerRef) {
            this.videoPlayerRef.muted = false
            this.videoPlayerRef.play().catch(() => {
              this.videoPlayerRef.muted = true
              this.videoPlayerRef.play().then(() => {
                setTimeout(() => { if (this.videoPlayerRef) this.videoPlayerRef.muted = false }, 100)
              })
            })
          }
        }, audioDelay)
      }

      this.syncToStore()
    },
    startSeek(e) {
      const rect = e.currentTarget.getBoundingClientRect()
      const updateSeek = (clientX) => {
        const pos = (clientX - rect.left) / rect.width
        const seekTime = Math.max(0, Math.min(pos * this.duration, this.duration))
        if (this.videoPlayerRef) {
          this.videoPlayerRef.currentTime = seekTime
        }
      }
      updateSeek(e.clientX)

      const onMouseMove = (moveEvent) => updateSeek(moveEvent.clientX)
      const onMouseUp = () => {
        document.removeEventListener('mousemove', onMouseMove)
        document.removeEventListener('mouseup', onMouseUp)
      }
      document.addEventListener('mousemove', onMouseMove)
      document.addEventListener('mouseup', onMouseUp)
    },
    updatePreviewState() {
      const container = document.querySelector('.standard-phone-screen')
      if (!container) return
      const containerRect = container.getBoundingClientRect()
      
      // 标准尺寸是 360x640
      const standardWidth = 360
      const standardHeight = 640
      
      this.previewScale = containerRect.width / standardWidth
      this.previewOffsetX = containerRect.left
      this.previewOffsetY = containerRect.top
    },
    
    // --- 播放器事件处理器 ---
    onPlayerPlay() {
      this.isPlaying = true
      this.syncToStore()
    },
    onPlayerPause() {
      this.isPlaying = false
      this.syncToStore()
    },
    onPlayerTimeUpdate(e) {
      const video = e.target
      this.currentTime = video.currentTime
      if (Math.floor(this.currentTime) % 2 === 0) {
        this.syncToStore()
      }
    },
    onPlayerLoadedMetadata(e) {
      const video = e.target
      this.duration = video.duration
      video.currentTime = this.$store.state.currentMedia?.currentTime || 0
      video.volume = this.volume
    },
    onVideoEnded() {
      this.isPlaying = false
      this.syncToStore()
    },
    onPlayerError(e) {
      const video = e.target
      if (!video.src || video.src.includes('/dynamic-title')) return
      console.error('Player error:', video.error)
    }
  },
  mounted() {
    // 从 Vuex store 初始化配置
    Object.assign(this.config, this.$store.state.dynamicTitleParams)
    
    // 根据当前选择的标题组初始化三段标题内容
    this.onGroupChange()
    
    this.startTimer()
    this.loadFixedDecorations()
    
    this.isPlaying = this.$store.state.currentMedia?.isPlaying || false
    this.currentTime = this.$store.state.currentMedia?.currentTime || 0
    this.duration = this.$store.state.currentMedia?.duration || 0
    this.volume = this.$store.state.currentMedia?.volume || 1
    
    this.unwatchVolume = this.$watch('volume', (newVol) => {
      if (this.videoPlayerRef) this.videoPlayerRef.volume = newVol
    })
    
    this.unwatchVideoUrl = this.$watch('videoUrl', async (newUrl) => {
      if (newUrl) {
        await this.$nextTick()
        if (this.videoPlayerRef) {
          this.videoPlayerRef.load()
        }
      }
    })
    
    // 监听配置变化并同步到 Vuex store
    this.unwatchConfig = this.$watch('config', (newConfig) => {
      this.$store.commit('UPDATE_DYNAMIC_TITLE_PARAMS', newConfig)
    }, { deep: true })
    
    this.unwatchGroupConfig = this.$watch(() => [
      this.config.currentGroupId, 
      this.config.intervalMin, 
      this.config.intervalMax
    ], () => {
      this.currentTitleIndex = 0
      this.onGroupChange() // 标题组切换时更新三段标题内容
      this.startTimer()
    }, { deep: true })
    
    // 更新预览状态并监听窗口大小变化
    this.$nextTick(() => {
      this.updatePreviewState()
    })
    
    this.handleResize = () => {
      if (this.resizeTimer) clearTimeout(this.resizeTimer)
      this.resizeTimer = setTimeout(() => {
        this.updatePreviewState()
      }, 100)
    }
    window.addEventListener('resize', this.handleResize)


    this.isPageActive = true
    this.isInitialSync = true

    // 启动 canvas 同步
    this.startCanvasSync()

    if (this.$store.state.currentMedia) {
      const mediaTime = this.$store.state.currentMedia.currentTime || 0
      if (mediaTime > 0.1) {
        this.currentTime = mediaTime
      }
      this.isPlaying = this.$store.state.currentMedia.isPlaying || false
      this.duration = this.$store.state.currentMedia.duration || 0
    }

    // 更新预览状态并监听窗口大小变化
    this.$nextTick(() => {
      this.updatePreviewState()
    })

    if (this.handleResize) {
      window.addEventListener('resize', this.handleResize)
    }

    this.performSync()


  },
  beforeDestroy() {
   /* if (this.timer) clearInterval(this.timer)
    this.stopPlaybackWatchdog()
    
    if (this.unwatchVolume) this.unwatchVolume()
    if (this.unwatchVideoUrl) this.unwatchVideoUrl()
    if (this.unwatchConfig) this.unwatchConfig()
    if (this.unwatchGroupConfig) this.unwatchGroupConfig()
    
    // 移除 resize 监听
    if (this.handleResize) {
      window.removeEventListener('resize', this.handleResize)
    }*/
  },
  activated() {

  },
  deactivated() {
   /* this.isPageActive = false
    this.stopPlaybackWatchdog()
    this.stopCanvasSync()

    if (this.videoPlayerRef) {
      const currentTimeToSave = this.videoPlayerRef.currentTime
      this.lastDeactivatedTime = Date.now()
      this.lastDeactivatedProgress = currentTimeToSave

      this.$store.commit('UPDATE_MEDIA_STATE', {
        currentTime: currentTimeToSave,
        isPlaying: this.isPlaying
      })

      if (!this.isVirtualCameraLive) {
        this.videoPlayerRef.pause()
        this.isMuted = true
      }
    }
    
    // 移除 resize 监听
    if (this.handleResize) {
      window.removeEventListener('resize', this.handleResize)
    }*/
  }
}
</script>

<style scoped>
.panel-card {
  background: rgba(20, 20, 20, 0.6); backdrop-filter: blur(10px); border: 1px solid rgba(255, 255, 255, 0.05);
  border-radius: 12px; overflow: hidden; box-shadow: 0 10px 30px rgba(0, 0, 0, 0.3), 0 0 20px rgba(0, 212, 255, 0.08);
  margin-bottom: -4px; /* 减小卡片之间的外边距 */
}
.tech-card { position: relative; }
.tech-card::before {
  content: ''; position: absolute; top: 0; left: 12px; right: 12px; height: 1px;
  background: linear-gradient(90deg, transparent, rgba(0, 212, 255, 0.4), transparent);
}
.card-header {
  display: flex; align-items: center; gap: 10px; padding: 12px 14px;
  background: linear-gradient(180deg, #151515 0%, #0f0f0f 100%); border-bottom: 1px solid #2a2a2a;
  color: #b0b0b0; font-size: 12px; font-weight: 600;
  border-radius: 12px 12px 0 0; /* 修复顶角溢出 */
}
.card-header span { font-size: 13px; font-weight: 600; color: #fff; flex: 1; }
.icon-wrapper {
  width: 24px; height: 24px; display: flex; align-items: center; justify-content: center;
  background: rgba(0, 212, 255, 0.12); border-radius: 8px; color: #00d4ff;
}

.card-body { padding: 10px; min-height: 145px; display: flex; flex-direction: column; overflow: visible !important; }
.config-list.disabled { opacity: 0.5; pointer-events: none; }

/* 布局辅助 */
.config-row-compact { display: flex; gap: 12px; align-items: flex-start; }
.flex-1 { flex: 1; }
.flex-2 { flex: 1.5; }

/* 分组表头样式 */
.section-divider {
  display: flex; align-items: center; gap: 10px;
}
.divider-dot {
  width: 4px; height: 4px; background: #00d4ff; border-radius: 50%; box-shadow: 0 0 8px #00d4ff;
}
.divider-text {
  font-size: 11px; color: #00d4ff; font-weight: 700; text-transform: uppercase; letter-spacing: 1px; white-space: nowrap;
}
.divider-line {
  flex: 1; height: 1px; background: linear-gradient(90deg, rgba(0, 212, 255, 0.2), transparent);
}

.select-wrapper-styled { width: 100%; position: relative; }
.input-wrapper-styled { background: rgba(0,0,0,0.4); border: 1px solid rgba(255,255,255,0.1); border-radius: 8px; padding: 2px 4px; }
.input-wrapper-styled-large {
  background: rgba(0, 212, 255, 0.05);
  border: 1px solid rgba(0, 212, 255, 0.3);
  border-radius: 10px;
  padding: 4px;
  transition: all 0.3s ease;
  box-shadow: inset 0 2px 10px rgba(0, 0, 0, 0.2);
}
.input-wrapper-styled-large:focus-within {
  border-color: rgba(0, 212, 255, 0.8);
  background: rgba(0, 212, 255, 0.1);
  box-shadow: 0 0 15px rgba(0, 212, 255, 0.2), inset 0 2px 10px rgba(0, 0, 0, 0.2);
}

.cyber-input-mini-styled {
  width: 100%; background: transparent; border: none; padding: 6px 10px; color: #fff; font-size: 12px; outline: none;
}
.cyber-input-large-styled {
  width: 100%;
  background: transparent;
  border: none;
  padding: 15px 18px;
  color: #fff;
  font-size: 15px;
  font-weight: 600;
  outline: none;
  min-height: 54px;
}
.cyber-input-large-styled::placeholder {
  color: rgba(0, 212, 255, 0.3);
}
.cyber-input-mini-styled:focus { color: #00d4ff; }
.cyber-input-large-styled:focus { color: #00d4ff; }
.no-arrows::-webkit-inner-spin-button, .no-arrows::-webkit-outer-spin-button { -webkit-appearance: none; margin: 0; }

/* 列表样式 */
.selected-list { display: flex; flex-direction: column; gap: 8px; max-height: 400px; overflow-y: auto; }
.selected-item {
  display: flex; align-items: center; gap: 12px; padding: 10px;
  background: rgba(255, 255, 255, 0.03); border: 1px solid #2a2a2a; border-radius: 8px;
}
.s-info { flex: 1; }
.s-name { font-size: 12px; color: #fff; font-weight: 600; }
.del-btn-icon { background: none; border: none; color: #555; cursor: pointer; padding: 4px; transition: color 0.2s; }
.del-btn-icon:hover { color: #ff6b6b; }
.empty-tip { text-align: center; color: #444; font-size: 12px; }

/* 配置项通用样式 */
.config-item { margin-bottom: 12px; }
.label-row { display: flex; justify-content: space-between; align-items: center; margin-bottom: 6px; }
.label-row label { font-size: 11px; color: #888; }
.value-tag { font-size: 10px; color: #00d4ff; background: rgba(0, 212, 255, 0.1); padding: 1px 6px; border-radius: 4px; }

.style-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 12px; }
.style-grid-quad { display: grid; grid-template-columns: repeat(4, 1fr); gap: 8px; }
.style-field {
  display: flex; flex-direction: column; align-items: stretch; gap: 4px; min-width: 0;
  background: rgba(255, 255, 255, 0.03); border: 1px solid rgba(255, 255, 255, 0.08);
  padding: 6px; border-radius: 8px; transition: all 0.3s ease;
}
.style-field:hover {
  background: rgba(255, 255, 255, 0.06); border-color: rgba(0, 212, 255, 0.3);
}
.style-field label { font-size: 10px; color: #888; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; text-align: center; margin-bottom: 2px; }

.color-picker-wrap { display: flex; align-items: center; gap: 4px; background: rgba(0,0,0,0.3); border: 1px solid #333; border-radius: 6px; padding: 2px 6px; }
.color-picker-wrap-compact {
  display: flex; align-items: center; justify-content: center; background: rgba(0,0,0,0.4);
  border: 1px solid rgba(255, 255, 255, 0.1); border-radius: 6px; padding: 2px; height: 28px; width: 100%; box-sizing: border-box;
}
.color-picker-wrap-compact input[type="color"] { width: 100%; height: 24px; border: none; background: none; cursor: pointer; padding: 0; flex: 1; border-radius: 4px; }

.opacity-input-mini { width: 22px; border: none; background: transparent; padding: 0; text-align: center; font-size: 11px; color: #00d4ff; outline: none; }
.full-color-mini { width: 100%; height: 28px; border: 1px solid rgba(255,255,255,0.1); background: rgba(0,0,0,0.4); border-radius: 6px; cursor: pointer; padding: 2px; box-sizing: border-box; transition: all 0.2s; }
.full-color-mini:hover { border-color: #00d4ff; transform: scale(1.02); }

.cyber-input-mini-compact { width: 100%; background: transparent; border: none; color: #fff; font-size: 11px; outline: none; text-align: center; font-weight: 600; }
.input-with-unit-compact { display: flex; align-items: center; justify-content: center; background: rgba(0,0,0,0.4); border: 1px solid rgba(255,255,255,0.1); border-radius: 6px; height: 28px; width: 100%; box-sizing: border-box; }

/* 迷你开关样式 */
.auto-switch-mini {
  position: relative; width: 32px; height: 18px; cursor: pointer; flex-shrink: 0; margin-left: 8px;
}
.auto-switch-mini input { opacity: 0; width: 0; height: 0; }
.auto-switch-track {
  position: absolute; inset: 0; background: rgba(255,255,255,0.1); border-radius: 20px; transition: 0.3s;
  border: 1px solid rgba(255,255,255,0.05);
}
.auto-switch-track::before {
  content: ''; position: absolute; height: 12px; width: 12px; left: 3px; bottom: 2px;
  background: #555; border-radius: 50%; transition: 0.3s;
}
.auto-switch-mini input:checked + .auto-switch-track { background: rgba(0, 212, 255, 0.2); border-color: rgba(0, 212, 255, 0.3); }
.auto-switch-mini input:checked + .auto-switch-track::before { transform: translateX(14px); background: #00d4ff; box-shadow: 0 0 8px rgba(0, 212, 255, 0.5); }

.icon-upload-btn-mini {
  width: 32px; height: 32px; display: flex; align-items: center; justify-content: center;
  background: rgba(255,255,255,0.05); border: 1px solid rgba(255,255,255,0.1);
  border-radius: 6px; cursor: pointer; color: #888; transition: all 0.2s;
  flex-shrink: 0;
}
.icon-upload-btn-mini:hover { background: rgba(76, 175, 80, 0.1); color: #4caf50; border-color: #4caf50; }

.color-picker-wrap input[type="color"] { width: 20px; height: 20px; border: none; background: none; cursor: pointer; padding: 0; }
.color-picker-wrap .opacity-input { width: 35px; border: none; background: transparent; padding: 0; text-align: center; font-size: 11px; color: #00d4ff; }
.color-picker-wrap .unit { font-size: 10px; color: #555; }

.full-color { width: 100%; height: 28px; border: 1px solid #333; background: rgba(0,0,0,0.3); border-radius: 6px; cursor: pointer; padding: 2px; }

.cyber-range {
  width: 100%; height: 4px; -webkit-appearance: none; background: #2a2a2a; border-radius: 2px; outline: none;
}
.cyber-range::-webkit-slider-thumb {
  -webkit-appearance: none; width: 12px; height: 12px; background: #00d4ff; border-radius: 50%; cursor: pointer; box-shadow: 0 0 10px #00d4ff;
}

/* 模板按钮 */
.template-grid { display: grid; grid-template-columns: repeat(3, 1fr); gap: 8px; margin-top: 8px; }
.tpl-btn {
  background: rgba(255, 255, 255, 0.05); border: 1px solid #333; color: #888;
  padding: 6px; border-radius: 6px; font-size: 11px; cursor: pointer; transition: all 0.2s;
}
.tpl-btn:hover { background: rgba(255, 255, 255, 0.08); border-color: #444; }
.tpl-btn.active { background: rgba(0, 212, 255, 0.1); border-color: #00d4ff; color: #00d4ff; }

/* 输入组 */
.input-group-mini { display: flex; gap: 8px; margin-bottom: 12px; align-items: center; }
.cyber-input-mini {
  flex: 1; background: rgba(0,0,0,0.3); border: 1px solid #333; border-radius: 6px;
  padding: 6px 10px; color: #fff; font-size: 12px; outline: none;
}
.cyber-input-mini:focus { border-color: #00d4ff; box-shadow: 0 0 10px rgba(0, 212, 255, 0.2); }

.cyber-select-mini {
  width: 100%;
  background: rgba(0,0,0,0.3);
  border: 1px solid #333;
  border-radius: 6px;
  padding: 6px 10px;
  color: #fff;
  font-size: 12px;
  outline: none;
  cursor: pointer;
  appearance: none;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 24 24' fill='none' stroke='%23888' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpolyline points='6 9 12 15 18 9'%3E%3C/polyline%3E%3C/svg%3E");
  background-repeat: no-repeat;
  background-position: right 10px center;
}
.cyber-select-mini:focus { border-color: #00d4ff; }

/* 自定义图片下拉样式 */
.custom-image-dropdown {
  position: relative;
  flex: 1;
  min-width: 0;
  user-select: none;
  z-index: 10001; /* 提升容器层级 */
}
.dropdown-header {
  height: 32px;
  background: rgba(0, 0, 0, 0.3);
  border: 1px solid #333;
  border-radius: 6px;
  padding: 0 10px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;
  transition: all 0.2s;
  font-size: 12px;
  color: #fff;
}
.header-left {
  display: flex;
  align-items: center;
  gap: 8px;
  min-width: 0;
  flex: 1;
}
.header-label {
  color: #00d4ff;
  font-weight: 800;
  font-size: 11px;
  flex-shrink: 0;
}
.v-line {
  width: 1px;
  height: 12px;
  background: rgba(255, 255, 255, 0.1);
  flex-shrink: 0;
}
.placeholder-text {
  color: #666;
  font-size: 11px;
}
.custom-image-dropdown.active .dropdown-header {
  border-color: #00d4ff;
  box-shadow: 0 0 10px rgba(0, 212, 255, 0.2);
}
.selected-preview {
  display: flex;
  align-items: center;
  gap: 8px;
  min-width: 0;
}
.selected-preview img {
  width: 20px;
  height: 20px;
  object-fit: contain;
  background: rgba(255, 255, 255, 0.05);
  border-radius: 3px;
}
.selected-preview span {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.arrow-icon {
  color: #666;
  transition: transform 0.2s;
}
.custom-image-dropdown.active .arrow-icon {
  transform: rotate(180deg);
  color: #00d4ff;
}

.dropdown-list {
  position: absolute;
  top: calc(100% + 5px); /* 恢复向下弹出 */
  left: 0;
  width: 280px;
  background: #1a1a1a;
  border: 1px solid #00d4ff;
  border-radius: 10px;
  box-shadow: 0 15px 35px rgba(0, 0, 0, 0.8), 0 0 20px rgba(0, 212, 255, 0.2);
  z-index: 99999; /* 极高层级确保置顶 */
  padding: 10px;
}
.dropdown-list-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 8px;
  margin-bottom: 8px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.05);
  font-size: 10px;
  color: #666;
}
.refresh-btn-mini {
  background: rgba(0, 212, 255, 0.1);
  border: 1px solid rgba(0, 212, 255, 0.2);
  color: #00d4ff;
  font-size: 9px;
  padding: 2px 6px;
  border-radius: 4px;
  cursor: pointer;
}
.refresh-btn-mini:hover {
  background: rgba(0, 212, 255, 0.2);
}
.dropdown-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 8px;
  max-height: 240px;
  overflow-y: auto;
  padding-right: 4px;
}
.dropdown-grid::-webkit-scrollbar { width: 4px; }
.dropdown-grid::-webkit-scrollbar-thumb { background: #333; border-radius: 2px; }

.dropdown-grid-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 5px;
  padding: 6px;
  background: rgba(255, 255, 255, 0.02);
  border: 1px solid rgba(255, 255, 255, 0.05);
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.2s;
}
.dropdown-grid-item:hover {
  background: rgba(0, 212, 255, 0.08);
  border-color: #00d4ff;
  transform: translateY(-2px);
}
.grid-img-box {
  width: 100%;
  aspect-ratio: 1;
  background: #000;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 4px;
  overflow: hidden;
}
.grid-img-box img {
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
}
.grid-item-name {
  font-size: 9px;
  color: #888;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 100%;
  text-align: center;
}
.dropdown-empty {
  padding: 30px 10px;
  text-align: center;
  color: #444;
}
.empty-icon { font-size: 24px; margin-bottom: 8px; opacity: 0.3; }
.dropdown-empty p { font-size: 12px; margin: 0; color: #666; }
.dropdown-empty small { font-size: 9px; color: #444; display: block; margin-top: 4px; word-break: break-all; }

/* 路径显示盒 */
.path-display-box {
  flex: 1;
  height: 32px;
  background: rgba(255, 255, 255, 0.03);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 6px;
  padding: 0 10px;
  display: flex;
  align-items: center;
  gap: 8px;
  min-width: 0;
  color: #666;
}
.path-text {
  font-size: 11px;
  font-family: monospace;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* 统一素材库样式 */
.unified-assets-scroll-box {
  background: rgba(0, 0, 0, 0.25);
  border: 1px solid rgba(255, 255, 255, 0.05);
  border-radius: 10px;
  overflow-y: auto; /* 上下滑动 */
  padding: 10px;
}
.unified-assets-scroll-box::-webkit-scrollbar { width: 4px; }
.unified-assets-scroll-box::-webkit-scrollbar-thumb { background: rgba(255, 255, 255, 0.1); border-radius: 2px; }

.unified-assets-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 10px;
}
.asset-item-box {
  aspect-ratio: 1;
  position: relative;
  background: rgba(255, 255, 255, 0.03);
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 8px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 5px;
  transition: all 0.2s;
}
.asset-item-box:hover {
  border-color: #00d4ff;
  background: rgba(0, 212, 255, 0.05);
  transform: translateY(-2px);
}
.asset-img-wrap {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
}
.asset-img-wrap img {
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
}
.asset-badge {
  position: absolute;
  top: -4px;
  left: -4px;
  background: #333;
  color: #aaa;
  font-size: 8px;
  padding: 1px 4px;
  border-radius: 4px;
  border: 1px solid rgba(255, 255, 255, 0.1);
  pointer-events: none;
}
.asset-badge.up { background: #004d40; color: #4db6ac; }

.asset-del-btn {
  position: absolute;
  top: -6px;
  right: -6px;
  width: 16px;
  height: 16px;
  background: #ff5252;
  color: white;
  border: none;
  border-radius: 50%;
  font-size: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  opacity: 0;
  transition: opacity 0.2s;
}
.asset-item-box:hover .asset-del-btn { opacity: 1; }

.upload-trigger {
  border: 2px dashed rgba(255, 255, 255, 0.1);
  color: rgba(255, 255, 255, 0.2);
}
.upload-trigger:hover {
  border-color: #4caf50;
  color: #4caf50;
  background: rgba(76, 175, 80, 0.05);
}

/* 之前样式的清理... */

.dropdown-item {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 8px;
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.2s;
}
.dropdown-item:hover {
  background: rgba(0, 212, 255, 0.1);
}
.item-img-box {
  width: 40px;
  height: 40px;
  background: rgba(0, 0, 0, 0.2);
  border: 1px solid rgba(255, 255, 255, 0.05);
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 4px;
}
.item-img-box img {
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
}
.item-name {
  font-size: 11px;
  color: #ccc;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.dropdown-empty {
  padding: 20px;
  text-align: center;
  color: #555;
  font-size: 12px;
}

.input-with-unit { display: flex; align-items: center; gap: 8px; }

.input-label-mini {
  font-size: 11px;
  color: #bbb;
  white-space: nowrap;
  font-weight: 600;
  min-width: 32px;
}

.send-btn-mini {
  background: #00d4ff; color: #000; border: none; border-radius: 6px;
  padding: 0 12px; font-size: 12px; font-weight: 600; cursor: pointer;
}

/* 开关样式 */
.header-toggle { position: relative; width: 32px; height: 18px; cursor: pointer; }
.header-toggle input { opacity: 0; width: 0; height: 0; }
.toggle-track {
  position: absolute; inset: 0; background: #333; border-radius: 18px; transition: .3s;
}
.toggle-track::before {
  content: ""; position: absolute; height: 14px; width: 14px; left: 2px; bottom: 2px; background: #fff; border-radius: 50%; transition: .3s;
}
input:checked + .toggle-track { background: #00d4ff; }
input:checked + .toggle-track::before { transform: translateX(14px); }

/* 独立拖拽预览样式 */
.draggable-title-container {
  position: absolute; inset: 0; pointer-events: none; z-index: 100;
}
.draggable-title-item, .draggable-title-group {
  position: absolute; pointer-events: auto; cursor: move; user-select: none;
  will-change: left, top; transition: box-shadow 0.2s, transform 0.2s;
}
.draggable-title-item:hover, .draggable-title-group:hover {
  filter: drop-shadow(0 0 8px rgba(0, 212, 255, 0.3));
}
.draggable-title-item.dragging {
  cursor: grabbing; transition: none; transform: scale(1.05); z-index: 110;
  filter: drop-shadow(0 0 15px rgba(0, 212, 255, 0.5));
}

/* 装饰图片样式 */
.draggable-dec-item {
  position: absolute; pointer-events: auto; cursor: move; user-select: none;
  z-index: 105;
}
.draggable-dec-item img { width: 100%; height: 100%; object-fit: contain; }
.draggable-dec-item.dragging { cursor: grabbing; transform: scale(1.05); z-index: 115; }
.dec-remove-btn {
  position: absolute; top: -8px; right: -8px; width: 18px; height: 18px;
  background: #ff4d4f; color: #fff; border: none; border-radius: 50%;
  font-size: 12px; cursor: pointer; display: none; align-items: center; justify-content: center;
}
.draggable-dec-item:hover .dec-remove-btn { display: flex; }

/* 旋转手柄 */
.dec-rotate-handle {
  position: absolute;
  top: -25px;
  left: 50%;
  transform: translateX(-50%);
  width: 22px;
  height: 22px;
  background: #ffeb3b;
  color: #000;
  border-radius: 50%;
  display: none;
  align-items: center;
  justify-content: center;
  cursor: alias;
  box-shadow: 0 0 10px rgba(255, 235, 59, 0.5);
  z-index: 120;
  border: 2px solid #000;
}
.draggable-dec-item:hover .dec-rotate-handle {
  display: flex;
}
.dec-rotate-handle::after {
  content: '';
  position: absolute;
  top: 20px;
  left: 50%;
  width: 2px;
  height: 8px;
  background: #ffeb3b;
  transform: translateX(-50%);
}
.dec-rotate-handle:hover {
  transform: translateX(-50%) scale(1.1);
  background: #fff;
}

/* 装饰库网格 */
/* 装饰库网格 - 主面板 */
.dec-library-grid-main {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 10px;
  margin-top: 5px;
  max-height: 200px;
  overflow-y: auto;
  padding: 5px;
  background: rgba(0, 0, 0, 0.2);
  border-radius: 8px;
  border: 1px solid rgba(255, 255, 255, 0.05);
}

.dec-thumb-item-main {
  aspect-ratio: 1;
  background: rgba(255, 255, 255, 0.03);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 8px;
  cursor: pointer;
  overflow: hidden;
  transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 6px;
  position: relative;
}

.dec-thumb-item-main:hover {
  border-color: #4caf50;
  background: rgba(76, 175, 80, 0.1);
  transform: translateY(-3px);
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.3);
}

.dec-thumb-item-main img {
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
  pointer-events: none;
}

.dec-badge {
  position: absolute;
  top: 2px;
  right: 2px;
  background: rgba(0, 212, 255, 0.8);
  color: #000;
  font-size: 9px;
  font-weight: 800;
  padding: 0 4px;
  border-radius: 4px;
  pointer-events: none;
}

.dec-upload-btn-main {
  aspect-ratio: 1;
  background: rgba(255, 255, 255, 0.05);
  border: 2px dashed rgba(255, 255, 255, 0.1);
  border-radius: 8px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  color: rgba(255, 255, 255, 0.3);
  transition: all 0.2s;
}

.dec-upload-btn-main:hover {
  border-color: #4caf50;
  color: #4caf50;
  background: rgba(76, 175, 80, 0.05);
}

.dec-library-grid {
  display: grid; grid-template-columns: repeat(4, 1fr); gap: 8px; margin-top: 10px;
}
.dec-thumb-item {
  aspect-ratio: 1; background: rgba(0,0,0,0.4); border: 1px solid rgba(255,255,255,0.1);
  border-radius: 6px; cursor: pointer; overflow: hidden; transition: all 0.2s;
  display: flex; align-items: center; justify-content: center; padding: 4px;
}
.dec-thumb-item:hover { border-color: #4caf50; transform: translateY(-2px); background: rgba(76, 175, 80, 0.1); }
.dec-thumb-item img { max-width: 100%; max-height: 100%; object-fit: contain; }

.dec-upload-btn {
  aspect-ratio: 1; background: rgba(255,255,255,0.05); border: 1px dashed rgba(255,255,255,0.2);
  border-radius: 6px; cursor: pointer; display: flex; align-items: center; justify-content: center;
  color: #888; transition: all 0.2s;
}
.dec-upload-btn:hover { border-color: #4caf50; color: #4caf50; background: rgba(76, 175, 80, 0.05); }

.dec-upload-btn-header {
  width: 24px; height: 24px; display: flex; align-items: center; justify-content: center;
  background: rgba(76, 175, 80, 0.1); border: 1px solid rgba(76, 175, 80, 0.2);
  border-radius: 6px; cursor: pointer; color: #4caf50; transition: all 0.2s;
  margin-left: 8px;
}
.dec-upload-btn-header:hover { background: rgba(76, 175, 80, 0.2); transform: scale(1.1); }

.live-bottom-area { margin-top: auto; padding: 12px; position: relative; }
.comment-gradient { position: absolute; bottom: 0; left: 0; width: 100%; height: 150px; background: linear-gradient(to top, rgba(0,0,0,0.8), transparent); z-index: -1; }
.comments-mock { display: flex; flex-direction: column; gap: 6px; }
.comment { background: rgba(0, 0, 0, 0.3); padding: 4px 10px; border-radius: 10px; font-size: 12px; color: #fff; width: fit-content; }
.comment span { color: #ffeb3b; font-weight: 700; margin-right: 4px; }

.player-control-bar {
  position: absolute; bottom: 0; left: 0; width: 100%; height: 0; opacity: 0; overflow: hidden;
  background: rgba(26, 26, 26, 0.9); backdrop-filter: blur(10px); padding: 0 16px; display: flex; align-items: center; gap: 15px;
  border-top: 1px solid rgba(255,255,255,0.05); transition: all 0.3s; z-index: 60; pointer-events: auto;
}
.standard-phone-frame:hover .player-control-bar { height: 60px; opacity: 1; padding: 10px 15px; }
.play-btn-mini { color: #00d4ff; cursor: pointer; display: flex; align-items: center; }
.progress-section { flex: 1; display: flex; flex-direction: column; gap: 6px; }
.progress-bar-wrap { height: 4px; background: rgba(255,255,255,0.1); border-radius: 2px; cursor: pointer; position: relative; }
.progress-fill { position: absolute; inset: 0 auto 0 0; background: #00d4ff; border-radius: 2px; box-shadow: 0 0 10px rgba(0,212,255,0.5); }
.time-info { display: flex; gap: 4px; font-size: 10px; color: #888; font-family: monospace; }
.volume-section { display: flex; align-items: center; gap: 8px; color: #888; }
.volume-slider-mini { width: 60px; height: 3px; -webkit-appearance: none; background: rgba(255,255,255,0.1); border-radius: 2px; outline: none; }
.volume-slider-mini::-webkit-slider-thumb { -webkit-appearance: none; width: 8px; height: 8px; background: #fff; border-radius: 50%; cursor: pointer; }

/* 直播间顶部 */
.live-header {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  padding: 12px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.user-info-capsule {
  display: flex;
  align-items: center;
  gap: 8px;
  background: rgba(0, 0, 0, 0.5);
  padding: 6px 10px;
  border-radius: 20px;
}

.user-info-capsule .avatar {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  overflow: hidden;
}

.user-info-capsule .avatar img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.user-info-capsule .meta {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.user-info-capsule .name {
  color: #fff;
  font-size: 13px;
  font-weight: 600;
}

.user-info-capsule .stats {
  color: rgba(255, 255, 255, 0.8);
  font-size: 11px;
}

.user-info-capsule .follow {
  background: #fe2c55;
  color: #fff;
  padding: 4px 12px;
  border-radius: 12px;
  font-size: 11px;
  font-weight: 600;
  cursor: pointer;
}

.viewer-tag {
  background: rgba(0, 0, 0, 0.5);
  padding: 4px 10px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  gap: 4px;
}

.viewer-tag .val {
  color: #fff;
  font-size: 12px;
  font-weight: 600;
}

.viewer-tag .lab {
  color: rgba(255, 255, 255, 0.7);
  font-size: 11px;
}

.icon-reset-btn { background: none; border: none; color: #666; cursor: pointer; padding: 4px; border-radius: 4px; transition: all 0.3s; }
.icon-reset-btn:hover { color: #ff6b6b; background: rgba(255, 107, 107, 0.1); }


</style>

